var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 1.33334V5.50001H1.81793M14.6151 7.16668C14.205 3.87808 11.3997 1.33334 8 1.33334C5.20219 1.33334 2.80691 3.05682 1.81793 5.50001M1.81793 5.50001H5.5M14.6667 14.6667V10.5H14.1821M14.1821 10.5C13.1931 12.9432 10.7978 14.6667 8 14.6667C4.60032 14.6667 1.795 12.1219 1.38491 8.83334M14.1821 10.5H10.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-circle.eb3ee281.svg";
export { ForwardRef as ReactComponent };